<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-2"><a id="_idTextAnchor003"></a>The Winds</h1>
<p class="Verse-first">The leaves have fallen</p>
<p class="Verse-main">The sky darker</p>
<p class="Verse-main">Autumns’ own lonely markers</p>
<p class="Verse-new">Leaves may fall</p>
<p class="Verse-main">But cases rise</p>
<p class="Verse-main">Sullen faces</p>
<p class="Verse-main">Masked disguise</p>
<p class="Verse-new">Pumpkins’ eyes light the night</p>
<p class="Verse-main">For October is the mask season</p>
<p class="Verse-main">But now horror has other reason</p>
<p class="Verse-new">People stand shoulder to shoulder</p>
<p class="Verse-main">Without a care</p>
<p class="Verse-main">No thought for the older</p>
<p class="Verse-new">To see them all flaunt the rules</p>
<p class="Verse-main">Diminish the losses</p>
<p class="Verse-main">Makes us all fools</p>
<p class="Verse-new">And when the days are shorter</p>
<p class="Verse-main">People move in</p>
<p class="Verse-main">Pulling crackers</p>
<p class="Verse-main">Hats worn without grin</p>
<p class="Verse-new">But Thursday nights remain silent</p>
<p class="Verse-main">The silence is loud</p>
<p class="Verse-main">Of my record</p>
<p class="Verse-main">I’m still proud</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398433502_EPUB6.vue?1bda7d6c